let productListing = {};
let currentEle;
let isInitialized = false, $slider = $('.js-product-listing-wrapper'), wasTriggered;
let productCategory = $('.product-listing-category');
let arlene = $('.custom-select-ui');

productListing.init = () => {
  if(!$slider) return;

  productListing.event('js-filter-icon');
};

productListing.event = (e) => {
  let ele = document.getElementsByClassName(e);
  for(let i = 0; i < ele.length; i++) {
    if(!ele[i]) return;

    ele[i].addEventListener('click', (e) => {
      productListing.actions(e);
      productListing.viewToggle(e);
      e.stopPropagation();
    });

    ele[i].addEventListener('touchstart', (e) => {
      productListing.actions(e);
      productListing.viewToggle(e);
      e.stopPropagation();
    });
  }
}

productListing.viewToggle = (e) => {
  if(e.target.id == "icon-toc") {
    if(isInitialized) {
      $slider.flickity('destroy');
      document.body.classList.remove('flickity-running');
      isInitialized = false;
      wasTriggered = false;
    }
  }

  if(e.target.id == "icon-array") {
    productListing.slider();
    document.body.classList.add('flickity-running');
    isInitialized = true;
    wasTriggered = true;
  }
}

productListing.slider = (e) => {
  let elChildLength = $slider.children().length;

  $slider.flickity({
    pageDots: (elChildLength > 1) ? true : false,
    contain: true,
    cellAlign: 'left',
    percentPosition: false,
    dragThreshold: 10,
    prevNextButtons: false,
    groupCells: false,
    wrapAround: false,
    freeScroll: true,
  });
}

//toggle action
productListing.actions = (e) => {
  if (!e) return;
  currentEle = e.target.id;

  if (!e.target.classList.contains('is-active')) {
    e.target.classList.add('is-active');
  } else {
    e.target.classList.remove('is-active');
  }

  productListing.checker();
}

//check btn which is active
productListing.checker = () => {
  let eleBtn = document.getElementsByClassName('js-filter-icon');
  if (!eleBtn) return;

  for (let i = 0; i < eleBtn.length; i++) {
    if (eleBtn[i].id !== currentEle) {
      eleBtn[i].classList.remove('is-active');
    }

    if (i > 10000) break;
  }
}

productListing.activeWindowedProducts = () => {
  if(window.innerWidth > 767) {
    if(isInitialized) {
      $slider.flickity('destroy');
      document.body.classList.remove('flickity-running');
      isInitialized = false;
    }
  } else {
    if(isInitialized || wasTriggered) {
      productListing.slider();
      document.body.classList.add('flickity-running');
      isInitialized = true;
    }
  }
}

document.addEventListener('DOMContentLoaded', function (event) {
  productListing.init();

  window.addEventListener('resize', () => {
    productListing.activeWindowedProducts();
  });

  $('.product-listing-category').on( 'change', function (event) {
    event.preventDefault();
    window.location.href = $(this).find('option:selected').attr("data-redirection-url");
  });
});



// WEBPACK FOOTER //
// ./scripts/components/product-listing.js